import log from '@justgiving/logger';
import clientConfig from 'config';

if (__SERVER__) {
  // tslint:disable-next-line:no-var-requires
  const serverConfig = require('config/server.config');
  log.setMinLevel(serverConfig.logLevel);
}

if (__CLIENT__) {
  log.setMinLevel(clientConfig.LOG_LEVEL);
}

export default log;
